import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login/login.vue';
import customFileUpload from '@/components/custom-file-upload/custom-file-upload.vue';
import fellowDashboard from '@/components/fellow-dashboard/fellow-dashboard.vue';

import Articles from '@/components/media/articles.vue';
import PressRelease from '@/components/media/pressRelease.vue';
import Careers from '@/components/Careers/careers.vue';

import eventDashboard from '@/components/event-dashboard/event-dashboard.vue';
import fieldStoryDashboard from '@/components/field-story-dashboard/field-story-dashboard.vue';
import reportDashboard from '@/components/report-dashboard/report-dashboard.vue';
import newsletterDashboard from '@/components/newsletter-dashboard/newsletter-dashboard.vue';
import guidelineDashboard from '@/components/guideline-dashboard/guideline-dashboard.vue';
import generalPublicationDashboard from '@/components/general-publication-dashboard/general-publication-dashboard.vue';
import issuedLetterDashboard from '@/components/issue-letter-dashboard/issue-letter-dashboard.vue';
import grDashboard from '@/components/gr-dashboard/gr-dashboard.vue';
import awpbDashboard from '@/components/awpb-dashboard/awpb-dashboard.vue';
import tenderAndProcurementDashboard from '@/components/tender-and-procurement-dashboard/tender-and-procurement-dashboard.vue';


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/awpbDashboard',
      name: 'awpbDashboard',
      component: awpbDashboard
    },
    {
      path: '/eventDashboard',
      name: 'eventDashboard',
      component: eventDashboard
    },
    {
      path: '/fellowDashboard',
      name: 'fellowDashboard',
      component: fellowDashboard
    },
    {
      path: '/fieldStoryDashboard',
      name: 'fieldStoryDashboard',
      component: fieldStoryDashboard
    },
    {
      path: '/issuedLetterDashboard',
      name: 'issuedLetterDashboard',
      component: issuedLetterDashboard
    },
    {
      path: '/generalPublicationDashboard',
      name: 'generalPublicationDashboard',
      component: generalPublicationDashboard
    },
    {
      path: '/guidelineDashboard',
      name: 'guidelineDashboard',
      component: guidelineDashboard
    },
    {
      path: '/grDashboard',
      name: 'grDashboard',
      component: grDashboard
    },
    {
      path: '/reportDashboard',
      name: 'reportDashboard',
      component: reportDashboard
    },
    {
      path: '/newsletterDashboard',
      name: 'newsletterDashboard',
      component: newsletterDashboard
    },
    {
      path: '/customFileUpload',
      name: 'customFileUpload',
      component: customFileUpload,
      meta: { requireAuth: true }
    },
    {
      path: '/articles',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/pressRelease',
      name: 'pressRelease',
      component: PressRelease
    },
    {
      path: '/careers',
      name: 'Careers',
      component: Careers
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/tenderAndProcurementDashboard',
      name: 'tenderAndProcurementDashboard',
      component: tenderAndProcurementDashboard
    }
  ]
})

router.beforeEach(function (to, from, next) {
  // alert('before each')
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next(false)
    }
  } else if (to.name === 'login' && localStorage.getItem('token')) {
    next(false)
  } else {
    next()
  }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js